module.exports = __webpack_public_path__ + "img/tanzania.1c15a03c.svg";